/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle01Icon16Light = forwardRef('NumberCircle01Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.86 11.22V4.01h-.757L5.639 5.888l.497.689 1.718-1.288v5.932H5.876V12h4.848v-.78H8.86Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.004a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-6 7a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
